module.exports = __webpack_public_path__ + "static/media/KS.fe66fe03.svg";